<template>
    <div class="legends">
        <table class="mds-data-table" v-for="group in groups" :key="group.id">
            <caption class="mds-data-table__caption">Here is where we want an accurate description about the data displayed and/or the table&#39;s intent</caption>
            <thead class="mds-data-table__header">
                <tr class="mds-data-table__row">
                    <th class="mds-data-table__header-cell" width="5%" scope="col">
                        <div class="mds-data-table__header-cell-inner"></div>
                    </th>
                    <th class="mds-data-table__header-cell" width="80%" scope="col">
                        <div class="mds-data-table__header-cell-inner">{{group.name}}</div>
                    </th>
                    <th class="mds-data-table__header-cell" width="15%" scope="col">
                        <div class="mds-data-table__header-cell-inner false mds-data-table__header-cell--right">{{group.value}}</div>
                    </th>
                </tr>
            </thead>
            <tbody class="mds-data-table__body">
                <tr class="mds-data-table__row" v-for="item in group.items" :key="item.name">
                    <td class="mds-data-table__cell" scope="row"><div class="color-block" :style="{ backgroundColor: item.color }"></div></td>
                    <td class="mds-data-table__cell" scope="row">{{item.name}}</td>
                    <td class="mds-data-table__cell false mds-data-table__cell--right">{{item.value}}%</td>
                </tr>
            </tbody>
        </table>
        <p class="assets-allocation__description mobile">{{$t('AssetsAllocationChartDescription')}}</p>
        <p class="assets-allocation__chart-description mobile" >{{$t('ChartDescription')}}</p>
    </div>
</template>

<script>
export default {
    props: {
        groups: {
            required: true,
            type: Array
        }
    }
};
</script>

<style lang="scss" scoped>
.color-block {
    width: 10px;
    height: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Legends.vue